const paths = {
  listDrivers: '/driver/list',
  editDrivers: '/driver/edit'
};

export default paths;
